<template>
  <div class="page-wrapper">
    <div class="container">
      <div class="row nav-container">
        <ul>
          <li><a href="#/admin/home/">메인</a></li>
          <li><a href="#/admin/checkin/">체크인</a></li>
          <li><a class="active" href="#/admin/settings/">세팅</a></li>
          <li><a href="#/admin/customers/">업체</a></li>
          <li><a href="#/admin/forwarders/">파트너</a></li>
          <li><a href="#/admin/users/">사용자</a></li>
          <li>
            <div class="logout" v-on:click="logout">로그아웃</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <h4>HS CODE</h4>
              </div>
            </div>
            <table class="table">
              <tr>
                <th>Name</th>
                <th>Old Code</th>
                <th>Code</th>
                <th>Priority</th>
                <th></th>
              </tr>
              <tr v-for="(item, index) in hsCode">
                <td><input type="text" class="form-control" v-model="item.title" @change="updateHsCodeItem(index)"/>
                </td>
                <td><input type="text" class="form-control" v-model="item.val" @change="updateHsCodeItem(index)"/></td>
                <td><input type="text" class="form-control" v-model="item.textVal" @change="updateHsCodeItem(index)"/></td>
                <td><i class="fa fa-check-square item-check"
                       v-bind:class="{'checked': item.val2 == 1, 'unchecked': item.val2 == 0}" v-on:click="updateHsVal2(index)"></i></td>
                <td>
                  <i class="fa fa-trash" v-on:click="deleteHsCodeItem(index)"></i>

                </td>
              </tr>
              <tr v-if="newHsCode != false">
                <td><input type="text" v-model="newHsCode.title"/></td>
                <td><input type="text" v-model="newHsCode.val"/></td>
                <td><input type="text" v-model="newHsCode.textVal"/></td>
                <td><input type="button" class="btn btn-primary" value="Add" v-on:click="submitNewHsCode()"/></td>
              </tr>
            </table>
            <input v-if="newHsCode==false" type="button" class="btn btn-primary" value="New HS Code"
                   v-on:click="openNewHsCodeForm()"/>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <h4>Country List</h4>
              </div>
            </div>
            <table class="table">
              <tr>
                <th>Country</th>
                <th>FTA</th>
                <th></th>
              </tr>
              <tr v-for="(item, index) in countryList">
                <td><input type="text" class="form-control" v-model="item.title"/></td>
                <td>{{ftaString(item.val)}}</td>
                <td>
                  <i class="fa fa-trash" v-on:click="deleteCountry(index)"></i>
                  </td>
              </tr>
              <tr v-if="newCountry != false">
                <td><input type="text" v-model="newCountry.title"/>
                <td>
                  <select v-model="newCountry.val">
                    <option value="-1">Select</option>
                    <option value="0">Non FTA</option>
                    <option value="1">FTA</option>
                  </select>

                <td><input type="button" class="btn btn-primary" value="Add" v-on:click="submitNewCountry()"/></td>
              </tr>
            </table>
            <input v-if="newCountry==false" type="button" class="btn btn-primary" value="New Country"
                   v-on:click="openNewCountryForm()"/>
          </div>
        </div>
      </div>

    </div>


    <v-dialog/>
  </div>
</template>
<script>
    import Router from '../router';
    import VModal from '../router';
    import axios from 'axios';
    import AdminNav from '@/components/AdminNav';

    export default {
        name: 'AdminSettings',

        data() {
            return {
                msg: 'Admin settings',
                hsCode: [],
                countryList: [],
                newHsCode: false,
                newCountry: false,
            }
        },
        created: function () {
            if(localStorage.getItem('id') == undefined || localStorage.getItem('id') == null || localStorage.getItem('id') === '') {
                Router.push('/admin');
                return;
            }
        },
        mounted: function () {
            this.getSettingList();
        },
        methods: {
            logout: function () {
                var self = this;
                this.$modal.show('dialog', {
                    //title: '로그아웃',
                    text: '로그아웃 하시겠습니까?',
                    buttons: [
                        {
                            title: '아니요',
                            handler: () => {
                                self.$modal.hide('dialog');

                            }
                        },
                        {
                            title: '로그아웃',
                            handler: () => {
                                self.$modal.hide('dialog');
                                self.onLogoutConfirmed();
                            }
                        },

                    ]

                });
            },
            onLogoutConfirmed: function () {
                localStorage.removeItem('id');
                localStorage.removeItem('email');
                localStorage.removeItem('level');
                localStorage.removeItem('admin');
                localStorage.removeItem('password');
                Router.push('/admin');
            },
            showModal: function (title, message) {
                console.log("show modal " + title + " : " + message);
                this.$modal.show('dialog', {
                    title: title,
                    text: message,
                    buttons: [
                        {title: 'Close'}
                    ]
                })
                return;
            },
            ftaString: function (val) {
                if (val == 0) {
                    return "None FTA";
                } else if (val == 1) {
                    return "FTA";
                } else {
                    return "Unknown";
                }
            },
            sortHsCode: function () {
                if (this.$data.hsCode != false && this.$data.hsCode.length > 0) {
                    this.$data.hsCode.sort(function (a, b) {
                        return a.val - b.val;
                    })
                }
            },
            getSettingList: function () {
                var self = this;
                axios.get(process.env.APP_URL + 'api/get_setting_list.php')
                    .then(response => {
                        console.log(response.data);
                        var data = response.data;
                        if (data['success'] == true) {
                            var list = data.list;
                            if (list.hasOwnProperty("hs_code")) {
                                self.$data.hsCode = list["hs_code"];
                                self.sortHsCode();
                            }
                            if (list.hasOwnProperty("country")) {
                                self.$data.countryList = list["country"];
                            }

                        } else {
                            //self.showModal("LOGIN FAIL", data['message']);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            openNewHsCodeForm: function () {
                this.$data.newHsCode = {
                    "title": "",
                    "val": 0,
                    "textVal":'',
                };

            },
            submitNewHsCode: function () {
                if (this.$data.newHsCode == false) {
                    return;
                }

                if (this.$data.newHsCode.title.length == 0) {
                    this.showModal("ERROR", "HS CODE TITLE is required");
                    return;
                }
                if (this.$data.newHsCode.val.length == 0) {
                    this.showModal("ERROR", "HS CODE value is required");
                    return;
                }
                var field_data = {
                    type: "hs_code",
                    title: this.$data.newHsCode.title,
                    val: this.$data.newHsCode.val,
                    textVal: this.$data.newHsCode.textVal,
                };
                var data = {
                    table: "meta_table",
                    data: field_data
                };
                this.$data.newHsCode = false;
                var self = this;
                axios.post(process.env.APP_URL + 'api/create.php', data)
                    .then(response => {
                        console.log(response);
                        var data = response.data;
                        if (data.success == true) {
                            self.hsCode.push(data.item);
                            self.sortHsCode();
                        } else {
                            self.showModal("ERROR", "Failed to create HS Code " + data.message);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        if(error.response !== undefined) {
                          console.log(error.response);
                        }
                    })

            },
            openNewCountryForm: function () {
                this.$data.newCountry = {
                    "title": "",
                    "val": -1
                };
            },

            deleteHsCodeItem: function (index) {
                console.log("deleteHS");
                if (this.$data.hsCode.length < index) {
                    console.log("deleteHS wrong");
                    return;
                }
                var self = this;
                this.$modal.show('dialog', {
                    title: 'WARNING',
                    text: this.$data.hsCode[index].title + ' 지우시겠습니까?',
                    buttons: [
                        {
                            title: '아니요',
                            handler: () => {
                                self.$modal.hide('dialog');

                            }
                        },
                        {
                            title: '지우기',
                            handler: () => {
                                self.$modal.hide('dialog');
                                self.onDeleteHsCodeConfirmed(index);
                            }
                        }
                    ]
                })
                return;

            },
            onDeleteHsCodeConfirmed: function (index) {
                var data = {
                    "id": this.$data.hsCode[index].id,
                    "deleted": 1,
                };
                var postData = {
                    "table": "meta_table",
                    "data": data,
                };
                var self = this;
                axios.post(process.env.APP_URL + 'api/update.php', postData)
                    .then(response => {
                        var data = response.data;
                        if (data.success) {
                            console.log("success");
                            self.$data.hsCode.splice(index, 1);
                        }
                    })
                    .catch(error => {
                        console.log("Error " + error);
                    })
            },
            updateHsVal2: function(index) {
                if (this.$data.hsCode.length < index) {
                    return;
                }
                if(this.$data.hsCode[index].val2 == 1) {
                    this.$data.hsCode[index].val2 = 0;
                } else {
                    this.$data.hsCode[index].val2 = 1;
                }
                this.updateHsCodeItem(index);

            },
            updateHsCodeItem: function (index) {
                if (this.$data.hsCode.length < index) {
                    return;
                }


                var data = {
                    "id": this.$data.hsCode[index].id,
                    "title": this.$data.hsCode[index].title,
                    "val": this.$data.hsCode[index].val,
                    "val2": this.$data.hsCode[index].val2,
                    "textVal": this.$data.hsCode[index].textVal,
                };
                var postData = {
                    "table": "meta_table",
                    "data": data,
                };
                var self = this;
                axios.post(process.env.APP_URL + 'api/update.php', postData)
                    .then(response => {
                        var data = response.data;
                        if (data.success) {
                            console.log("success");
                            self.sortHsCode();
                        }
                    })
                    .catch(error => {
                        console.log("Error " + error);
                    })
            },
            submitNewCountry: function () {
                if (this.$data.newCountry == false) {
                    return;
                }

                if (this.$data.newCountry.title.length == 0) {
                    this.showModal("ERROR", "Country name is required");
                    return;
                }
                if (this.$data.newCountry.val == -1) {
                    this.showModal("ERROR", "Select FTA type");
                    return;
                }
                var field_data = {
                    type: "country",
                    title: this.$data.newCountry.title,
                    val: this.$data.newCountry.val
                };
                var data = {
                    table: "meta_table",
                    data: field_data
                };
                this.$data.newCountry = false;
                var self = this;
                axios.post(process.env.APP_URL + 'api/create.php', data)
                    .then(response => {
                        console.log(response);
                        var data = response.data;
                        if (data.success == true) {
                            self.countryList.push(data.item);
                        } else {
                            self.showModal("ERROR", "Failed to create HS Code " + data.message);
                        }
                    })
                    .catch(error => {

                    })
            },
            deleteCountry: function(index) {
                var self = this;
                this.$modal.show('dialog', {
                    title: 'WARNING',
                    text: this.$data.countryList[index].title + ' 지우시겠습니까?',
                    buttons: [
                        {
                            title: '아니요',
                            handler: () => {
                                self.$modal.hide('dialog');

                            }
                        },
                        {
                            title: '지우기',
                            handler: () => {
                                self.$modal.hide('dialog');
                                self.onDeleteCountryConfirmed(index);
                            }
                        }
                    ]
                })
                return;
            },
            onDeleteCountryConfirmed: function (index) {
                var data = {
                    "id": this.$data.countryList[index].id,
                    "deleted": 1,
                };
                var postData = {
                    "table": "meta_table",
                    "data": data,
                };
                var self = this;
                axios.post(process.env.APP_URL + 'api/update.php', postData)
                    .then(response => {
                        var data = response.data;
                        if (data.success) {
                            console.log("success");
                            self.$data.countryList.splice(index, 1);
                        }
                    })
                    .catch(error => {
                        console.log("Error " + error);
                    })
            },

        }

    }
</script>
<style>
  .item-check {
    font-size: 30px;
  }

  .checked {
    color: red;
  }

  .unchecked {
    color: gray;
  }
  td > .fa {
    font-size: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/AdminSettings.vue